import { COURSES_ACTIONS } from './actionTypes';

export const coursesInitState = {
	courses: [],
	currentCourse: undefined,
};

const coursesReducer = (state, action) => {
	switch (action.type) {
		case COURSES_ACTIONS.SET_COURSES:
			return {
				...state,
				courses: [...action.payload],
			};
		case COURSES_ACTIONS.SET_CURRENT_COURSE:
			return { ...state, currentCourse: action.payload };
		default:
			return state;
	}
};
export default coursesReducer;
